import scroll from './helpers/scroll'
import behave from "./helpers/behave";
import resize from "./helpers/resize";

behave('.footer-btn', element => {
    const btn = element.querySelector('.footer-btn-int')

    let offset;

    resize(() => {
        const padding = parseInt(getComputedStyle(element).getPropertyValue('--padding'));
        offset = padding + element.offsetHeight
    })

    scroll(() => {
        const detach = element.getBoundingClientRect().top > window.innerHeight - offset
        element.classList.toggle('footer-btn--detach', detach)
    })
})
